export default function (activities) {
  const data = {
    competition_ids: [],
    poll_ids: [],
    survey_ids: []
  }

  activities.forEach((activity) => {
    switch (activity.type()) {
      case 'competition':
        data.competition_ids.push(activity.id)
        break

      case 'survey':
        data.survey_ids.push(activity.id)
        break

      default:
        data.poll_ids.push(activity.id)
    }
  })

  return data
}
